module.exports = __webpack_public_path__ + "static/img/banner-4.90865c3a.png";